exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-customCheckboxList-v2{width:208px;border-radius:.285rem;border:solid 1px #dfe2e7;background-color:#fff;margin-right:.857rem}.cap-customCheckboxList-v2 .div-icon{width:208px;height:88px;padding:20px 80px;border-radius:4px;background-color:#e9f0fe}.cap-customCheckboxList-v2 .div-icon .customCheckbox-Icon{margin:1.428rem 5.714rem;width:48px;height:48px;padding:.571rem .285rem}.cap-customCheckboxList-v2 .customCheckbox-inductive-text{width:168px;height:48px}.cap-customCheckboxList-v2 .customCheckbox{padding:1.142rem 1.714rem 1.142rem 1.142rem}\n", ""]);

// exports
